import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { useMenuModel } from '@entities/menu'
import { useRestaurantModel } from '@entities/restaurant'
import IconLotPlaceholder from '~/components/Icon/IconLotPlaceholder.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuCartList',
  props: {
  currencyIcon: {
    type: String as PropType<string>,
    required: false,
    default: ''
  }
},
  emits: ['setDetailProduct'],
  setup(__props, { emit }) {

const props = __props



const restaurantModel = useRestaurantModel()
const menuModel = useMenuModel()



const isUnavailable = (item: any): boolean => {
  return menuModel.unavailableDishIds.has(item.id)
}

const hasUnavailableModifiers = (item: any): boolean => {
  const cartItemId = item.cartItemId || String(item.id)
  const unavailableModifiers = menuModel.unavailableModifierIds.get(cartItemId)
  return unavailableModifiers ? unavailableModifiers.size > 0 : false
}

const isModifierUnavailable = (item: any, modifierId: number): boolean => {
  const cartItemId = item.cartItemId || String(item.id)
  const unavailableModifiers = menuModel.unavailableModifierIds.get(cartItemId)
  return unavailableModifiers ? unavailableModifiers.has(modifierId) : false
}

const handleItemClick = (item: any) => {
  // Находим продукт в меню по id
  let product = null
  menuModel.menuUser.forEach((category) => {
    const found = category.products.find(p => p.id === item.id)
    if (found) {
      product = found
    }
  })
  if (product) {
    // Если блюдо в стоп-листе или имеет недоступные модификаторы,
    // передаем cartItem для удаления при замене, но открываем в дефолтном состоянии
    const isUnavailableDish = isUnavailable(item)
    const hasUnavailableMods = hasUnavailableModifiers(item)

    if (isUnavailableDish || hasUnavailableMods) {
      // Передаем cartItem, но с флагом, что нужно открыть в дефолтном состоянии
      emit('setDetailProduct', { product, cartItem: item, openAsNew: true })
    } else {
      emit('setDetailProduct', { product, cartItem: item })
    }
  }
}

const getModifiers = (item: any): Array<{ modifier: any, count: number }> => {
  if (!item.selectedModifiers || item.selectedModifiers.length === 0) {
    return []
  }

  // Получаем модификаторы из меню (чтобы получить актуальный external_id)
  let productFromMenu: any = null
  menuModel.menuUser.forEach((category: any) => {
    const found = category.products.find((p: any) => p.id === item.id)
    if (found) {
      productFromMenu = found
    }
  })

  // Собираем все доступные модификаторы из меню (приоритет) или из корзины (fallback)
  const available: any[] = []
  if (productFromMenu) {
    // Получаем модификаторы из меню
    if (Array.isArray(productFromMenu.modifiers)) {
      available.push(...productFromMenu.modifiers)
    }
    if (Array.isArray(productFromMenu.modifier_groups)) {
      productFromMenu.modifier_groups.forEach((group: any) => {
        if (Array.isArray(group.modifiers)) {
          available.push(...group.modifiers)
        }
      })
    }
  } else {
    // Fallback: получаем модификаторы из элемента корзины
    if (Array.isArray(item.modifiers)) {
      available.push(...item.modifiers)
    }
    if (Array.isArray(item.modifier_groups)) {
      item.modifier_groups.forEach((group: any) => {
        if (Array.isArray(group.modifiers)) {
          available.push(...group.modifiers)
        }
      })
    }
  }

  if (available.length === 0) {
    return []
  }

  // Группируем модификаторы по ID и считаем количество
  const modifierCountMap = new Map<number, { modifier: any, count: number }>()
  item.selectedModifiers.forEach((modifierId: number) => {
    const modifier = available.find((m: any) => m.id === modifierId)
    if (modifier) {
      const existing = modifierCountMap.get(modifierId)
      if (existing) {
        existing.count += 1
      } else {
        modifierCountMap.set(modifierId, { modifier, count: 1 })
      }
    }
  })

  return Array.from(modifierCountMap.values())
}

return { __sfc: true,props, restaurantModel, menuModel, emit, isUnavailable, hasUnavailableModifiers, isModifierUnavailable, handleItemClick, getModifiers, IconLotPlaceholder }
}

})